var _path, _mask, _g, _mask2, _g2, _rect, _g3, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewNewDataRoom = function SvgViewNewDataRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-new-data-room_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-new-data-room_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.813 181.482H468.864A129.192 129.192 0 01598.051 52.351H947a129.192 129.192 0 01-129.187 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.511 129.131H281.565A129.193 129.193 0 01410.755 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.014 292H359.51a129.195 129.195 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01520.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-new-data-room_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-new-data-room_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C271.533 562.928 239.889 576 206.894 576zM40.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0140.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.641 496.685H47.333c.013-32.915 13.157-64.478 36.541-87.748 23.384-23.27 55.094-36.342 88.157-36.342h255.248a123.512 123.512 0 01-9.466 47.497 123.969 123.969 0 01-27.015 40.268 124.606 124.606 0 01-40.447 26.898 125.055 125.055 0 01-47.71 9.427z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 196,
    width: 277,
    height: 164,
    rx: 5,
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.776 267.365h29.306c1.811 0 2.305.494 2.305 2.469v20.581c0 1.317-.658 1.975-1.975 1.975h-59.766c-.987-.164-1.646-.658-1.646-1.811v-21.403c0-.988.659-1.647 1.646-1.811h30.13zm-16.794 11.031h-8.067c-1.153 0-1.976.658-1.976 1.646 0 .988.823 1.647 1.976 1.647h16.135c1.152 0 1.976-.659 1.976-1.647s-.824-1.646-1.976-1.646h-8.068zm38.856 0h-2.799c-.988 0-1.811.658-1.811 1.646 0 .988.659 1.647 1.811 1.647h5.763c.987 0 1.811-.824 1.811-1.811 0-.988-.824-1.647-1.811-1.647-.988.165-1.976.165-2.964.165zM330.776 260.943h-29.471c-1.646 0-2.305-.494-2.305-2.141v-20.745c0-1.481.659-2.14 2.14-2.14h59.107c1.646 0 2.305.659 2.305 2.305v20.416c0 1.975-.494 2.469-2.47 2.469-9.714-.164-19.592-.164-29.306-.164zm-16.794-10.867h8.068c1.152 0 1.811-.658 1.976-1.646 0-.988-.659-1.811-1.811-1.811h-16.3c-1.317 0-1.976.823-1.976 1.811s.823 1.646 1.976 1.646h8.067zm38.856 0h2.799c.988 0 1.811-.658 1.811-1.646 0-.988-.659-1.811-1.646-1.811h-5.928c-.987 0-1.646.823-1.646 1.811s.823 1.646 1.811 1.646h2.799zM330.776 323.836H301.47c-1.976 0-2.47-.494-2.47-2.305v-20.416c0-1.647.494-2.14 2.14-2.14h59.107c1.646 0 2.14.493 2.14 2.14v20.58c0 1.647-.494 2.141-2.14 2.141h-29.471zm-16.794-10.373h7.903c1.317 0 1.976-.659 1.976-1.646 0-.988-.823-1.647-1.976-1.647h-15.97c-1.153 0-1.976.659-1.976 1.647 0 .987.823 1.646 1.976 1.646 2.634.165 5.433 0 8.067 0zm38.856.165h2.799c1.152 0 1.976-.824 1.976-1.811 0-.988-.824-1.647-1.976-1.647h-5.598c-1.152 0-1.811.659-1.811 1.647 0 .987.823 1.646 1.811 1.646.988.165 1.976.165 2.799.165z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348 363h-34v21h-43v7h120v-7h-43v-21z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360.432,
    cy: 314.432,
    r: 15.932,
    fill: "#33BB40",
    stroke: "#2C3E50",
    strokeWidth: 3
  })));
};

export default SvgViewNewDataRoom;